import { setGuestSessionExpiredHandler } from '@pulse/utils/guest-session';

import { isSafeReturnPath, setGuestReturnPath } from '~/support/guest-return-path';

/**
 * Sessions are short enough that a customer who stops to find a photo can expire mid-claim. Without
 * this they would just see a failed request; here they get sent back through lookup, and the claim
 * itself is restored from the server-side claim session once they are back.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter();

  setGuestSessionExpiredHandler(() => {
    const current = router.currentRoute.value.fullPath;

    // Only claim pages are worth resuming; expiring on /start itself must not loop.
    if (isSafeReturnPath(current)) setGuestReturnPath(current);

    if (router.currentRoute.value.path !== '/start') navigateTo('/start');
  });
});
